import React from "react";
import axios from "axios";
import { Card, Row, Col, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faShoppingBag,
    faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { renderLoadingProgressToast } from "components/shared/Toasts";
import { useLoaderData, useNavigate } from "react-router";

export async function loader() {
    const records = await renderLoadingProgressToast(
        axios.get("wishlistitem/summary")
    ).then((response) => response.data);
    return { ...records };
}

const Dashboard = () => {
    const { items_with_tracking_events, items_with_item_events } =
        useLoaderData();
    const nav = useNavigate();

    return (
        <Container>
            <header className="mb-4">
                <p className="text-gray-600">
                    Welcome back! Here's your overview.
                </p>
            </header>

            <Row>
                <Col md={6} className="mb-4">
                    <Card className="h-100">
                        <Card.Body>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <Card.Title className="text-muted h6">
                                        Product Events
                                    </Card.Title>
                                    <h2
                                        className="text-primary fw-bold"
                                        style={{ cursor: "pointer" }}
                                        data-testid="item_event_count"
                                        onClick={() =>
                                            nav(
                                                "/wishlist?with_item_event=true"
                                            )
                                        }
                                    >
                                        {items_with_item_events}
                                    </h2>
                                </div>
                                <div className="bg-primary bg-opacity-10 p-3 rounded-circle">
                                    <FontAwesomeIcon
                                        icon={faShoppingBag}
                                        className="text-primary"
                                        size="lg"
                                    />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6} className="mb-4">
                    <Card className="h-100">
                        <Card.Body>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <Card.Title className="text-muted h6">
                                        Alerts
                                    </Card.Title>
                                    <h2
                                        className="text-danger fw-bold"
                                        style={{ cursor: "pointer" }}
                                        data-testid="tracking_event_count"
                                        onClick={() =>
                                            nav(
                                                "/wishlist?with_tracking_event=true"
                                            )
                                        }
                                    >
                                        {items_with_tracking_events}
                                    </h2>
                                </div>
                                <div className="bg-danger bg-opacity-10 p-3 rounded-circle">
                                    <FontAwesomeIcon
                                        icon={faExclamationCircle}
                                        className="text-danger"
                                        size="lg"
                                    />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Dashboard;
